import { Transition } from "../Transition/index.js";
class FrameLoader extends Transition {
  /**
   * Config.
   */
  static config = {
    name: "FrameLoader"
  };
  // @ts-expect-error this is fine.
  get $options() {
    const options = super.$options;
    return {
      ...options,
      enterKeep: true,
      leaveKeep: true
    };
  }
}
export {
  FrameLoader
};
//# sourceMappingURL=FrameLoader.js.map
